var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',_vm._g(_vm._b({attrs:{"value":_vm.value,"attach":_vm.dialogRoot},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-dialog',_vm.$attrs,false),_vm.$listeners),[_c('template',{slot:"activator"},[_vm._t("activator")],2),[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }